module.exports = __webpack_public_path__ + "media/recipes/46-97792f29.png";